"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _I18n = _interopRequireDefault(require("I18n"));

var API_BASE = 'ads/v1';
var THIRTY_SECONDS_IN_MS = 30000;

var AdsROIAPI =
/*#__PURE__*/
function () {
  function AdsROIAPI() {
    (0, _classCallCheck2.default)(this, AdsROIAPI);
  }

  (0, _createClass2.default)(AdsROIAPI, null, [{
    key: "getCostPerLead",
    value: function getCostPerLead() {
      return _apiClient.default.get(API_BASE + "/profile/desired-cost-per-lead", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "syncCostPerLead",
    value: function syncCostPerLead(costPerLead) {
      var data = (0, _extends2.default)({}, costPerLead, {
        avgSalePrice: _I18n.default.parseNumber(costPerLead.avgSalePrice)
      });
      return _apiClient.default.put(API_BASE + "/profile/desired-cost-per-lead", {
        timeout: THIRTY_SECONDS_IN_MS,
        data: data
      });
    }
  }, {
    key: "syncROISetting",
    value: function syncROISetting(roiType) {
      return _apiClient.default.post(API_BASE + "/profile/roi-setting", {
        timeout: THIRTY_SECONDS_IN_MS,
        data: {
          roiType: roiType
        }
      });
    }
  }, {
    key: "fetchPortalCurrencyInfo",
    value: function fetchPortalCurrencyInfo() {
      var url = "multi-currency/v1/currencies/information";
      return _apiClient.default.get(url, {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }]);
  return AdsROIAPI;
}();

exports.default = AdsROIAPI;
module.exports = exports.default;